class CartIconBubble extends HTMLElement{
    connectedCallback(){
        document.addEventListener('cart:updated', (e) => {
            this.update(e.detail);
        })
    }

    update(cart){
        const sup = this.querySelector('sup');

        if (sup) {
            sup.textContent = cart.item_count;
        }
        this.style.display = cart.item_count > 0 ? '' : 'none';
    }
}

customElements.define('cart-icon-bubble', CartIconBubble);